<template>
    <div
        :style="`height:${height}px; width:${width}px`"
    >
        <Bar
            :data="chartData"
            :options="computedOptions"
            :height="height"
            :width="width"
        />
    </div>
</template>

<script>
import {Bar} from 'vue-chartjs';

export default {
    name: 'BarChart',
    components: {Bar},
    props: {
        chartData: {type: Object, required: true},
        xAxesLabelString: {type: String, required: true},
        yAxesLabelString: {type: String, required: true},
        height: {
            type: Number,
            default: 350,
        },
        width: {
            type: Number,
            default: 350,
        },
        integerOnly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        computedOptions() {
            const yAxesList = this.yAxesLabelString.split('<br>');
            const dataset = this.chartData.datasets[0] || {};
            const isPercent = dataset.isPercentValue;
            const maxValue = dataset.maxValue || undefined;

            // precision: 0 erzwingt ganzzahlige Tick-Werte für "Anzahl …"-Kennzahlen,
            // damit die y-Achse keine 0,5/1,5-Schritte mehr anzeigt. Prozentwerte sind
            // ausgeklammert (dort sind 0,5 etc. korrekt).
            const integerTicks = this.integerOnly && !isPercent;

            const baseYAxis = {
                beginAtZero: true,
                suggestedMax: maxValue,
                ticks: {
                    ...(integerTicks ? {precision: 0} : {}),
                    callback: value =>
                        isPercent ? `${(value * 100).toFixed(0)} %` : value.toString().replace('.', ','),
                    font: {
                        family: "'Source Sans Pro'",
                        size: 13,
                    },
                },
                title: {
                    display: true,
                    text: yAxesList.length === 2 ? yAxesList[1] : yAxesList[0],
                    font: {
                        family: "'Source Sans Pro'",
                        size: 13,
                    },
                },
            };

            const extraYAxis =
                yAxesList.length === 2
                    ? {
                        display: true,
                        position: 'right',
                        grid: {display: false},
                        ticks: {display: false},
                        title: {
                            display: true,
                            text: yAxesList[0],
                            font: {
                                family: "'Source Sans Pro'",
                                size: 13,
                            },
                        },
                    }
                    : undefined;

            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                        labels: {
                            font: {
                                family: "'Source Sans Pro'",
                                size: 13,
                            },
                        },
                    },
                    tooltip: {
                        callbacks: {
                            title: tooltipItems => tooltipItems[0]?.label,
                            label: tooltipItem => {
                                let label = tooltipItem.dataset.label || '';
                                if (label) label += ': ';
                                const y = tooltipItem.raw?.y ?? tooltipItem.parsed.y;
                                label += isPercent ? `${(y * 100).toFixed(0)} %` : y.toString().replace('.', ',');
                                return label;
                            },
                        },
                    },
                },
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: this.xAxesLabelString,
                            font: {
                                family: "'Source Sans Pro'",
                                size: 13,
                            },
                        },
                        ticks: {
                            font: {
                                family: "'Source Sans Pro'",
                                size: 13,
                            },
                        },
                    },
                    y: baseYAxis,
                    ...(extraYAxis ? {y1: extraYAxis} : {}),
                },
            };
        },
    },
};
</script>

<style scoped>
</style>
